export const getDistinctFilteredForms = (filteredForms) => {
  let filteredFormsList = [];
  filteredForms.forEach((filteredForm) => {
    if (filteredForm?.length === 0) {
      filteredFormsList.push(filteredForm);
    } else {
      let exstingForms = filteredFormsList.find(
        (c) =>
          c.formTitle === filteredForm.formTitle &&
          c.templateId === filteredForm.templateId
      );
      if (!exstingForms) {
        filteredFormsList.push(filteredForm);
      }
    }
  });
  return filteredFormsList;
};
